import React from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { useToast } from 'use-toast-mui';

import { FormInputText } from '../../../form-components/FormInputText';
import CommonModalButton from '../../../form-components/CommonModalButton';
import { registerSmsSender } from '../../../api/sms';
import {
  ModalBox,
  ModalHeader,
  ModalTitle,
  ModalBody,
  FieldRow,
  FieldLabel,
  FieldControl,
  ModalFooter,
} from './SmsSenderRegisterModalStyled';

const SmsSenderRegisterModal = ({ open, branchId, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const toast = useToast();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: { senderName: '', senderNumber: '' },
  });

  const registerMutation = useMutation({
    mutationFn: form =>
      registerSmsSender(branchId, { senderName: form.senderName, senderNumber: form.senderNumber }, user?.token),
    onSuccess: () => {
      toast.success(t('발신번호가 등록되었습니다'));
      reset();
      onSuccess();
    },
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  const onSubmit = form => {
    if (!form.senderName?.trim()) {
      toast.error(t('발신자명을 입력해주세요'));
      return;
    }
    if (!String(form.senderNumber || '').trim()) {
      toast.error(t('발신번호를 입력해주세요'));
      return;
    }
    registerMutation.mutate(form);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalBox>
        <ModalHeader>
          <ModalTitle>{t('발신번호 등록')}</ModalTitle>
          <IconButton onClick={handleClose} size="small" sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </ModalHeader>

        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <FieldRow>
              <FieldLabel>{t('발신자명')}</FieldLabel>
              <FieldControl>
                <FormInputText control={control} name="senderName" placeholder={t('발신자명을 입력해주세요')} />
              </FieldControl>
            </FieldRow>

            <FieldRow>
              <FieldLabel>{t('발신번호')}</FieldLabel>
              <FieldControl>
                <FormInputText
                  control={control}
                  name="senderNumber"
                  placeholder={t('숫자만 입력 (예: 0212345678)')}
                />
              </FieldControl>
            </FieldRow>
          </ModalBody>

          <ModalFooter>
            <CommonModalButton variant="cancel" type="button" onClick={handleClose}>
              {t('취소')}
            </CommonModalButton>
            <CommonModalButton variant="submit" type="submit" disabled={registerMutation.isPending}>
              {t('등록')}
            </CommonModalButton>
          </ModalFooter>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default SmsSenderRegisterModal;
